import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import parse from 'html-react-parser';
import data from "../../data/mainData.json";

class Testimonial extends Component {

    render() {

        let publicUrl = process.env.PUBLIC_URL+'/'
        let imagealt = 'image'

    return <div className="ltn__testimonial-area section-bg-1--- bg-image-top pt-115 pb-70" data-bs-bg={publicUrl+"assets/img/bg/20.jpg"}>
			  <div className="container">
			    <div className="row">
			      <div className="col-lg-12">
			        <div className="section-title-area ltn__section-title-2--- text-center">
			          <h6 className="section-subtitle section-subtitle-2 ltn__secondary-color">Our Testimonial</h6>
			          <h1 className="section-title">Clients Feedback</h1>
			        </div>
			      </div>
			    </div>
				
			    <div className="row ltn__testimonial-slider-5-active slick-arrow-1">
                        {data?.testimonials?.map((item) => (
                            <div className="col-lg-4" key={item.id}>
                                <div className="ltn__testimonial-item ltn__testimonial-item-7">
                                    <div className="ltn__testimoni-info">
                                        <div className="ltn__testimonial-video">
                                            <video width="100%" height="100%" controls  controlsList="nodownload"
                                                    disablePictureInPicture
                                                    onContextMenu={(e) => e.preventDefault()}>
                                                <source
                                                    src={item.video}
                                                    type="video/mp4"
                                                />
                                                Your browser does not support the video tag.
                                            </video>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}

                    </div>
			  </div>
			</div>

        }
}

export default Testimonial